var React = require('react');
var createReactClass = require('create-react-class');
var assign = require('object-assign');
var FuzzyReaction = require('../../bootstrap').FuzzyReaction;
var Table = FuzzyReaction.Components.Visualization.Tables.Table;
var Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
var PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
var PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
var Modal = FuzzyReaction.Components.Global.Modal;
var Column = FuzzyReaction.Components.PageStructure.Column;
var Row = FuzzyReaction.Components.PageStructure.Row;
var AddAction = FuzzyReaction.Components.ResourceBinding.CreateResourceAction;
var ResourceActions = FuzzyReaction.Actions.ResourceActions;
var Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
var FormStore = FuzzyReaction.Stores.FormStore;
var MovementsStore = require('../../stores/MovementsStore');

var MovementsPage = createReactClass({
    displayName: 'MovementsPage',

    getInitialState: function () {
		return {
			currentPageData:     [],
			workingResource:     {},
			openDeactivateModal: false,
			openEditModal:       false
		}
	},

    getOptions: {
		modifiers: {},
		dataNode:  'data'
	},

    sendOptions: {
		modifiers: {
			other: {
				show_deleted: true
			}
		},
		dataNode: 'data'
	},

    /**
	 * Set up resource actions
	 */
    resourceAction: new ResourceActions('movements'),

    /**
	 * Fire an action to request data from the API
	 */
    requestTableData: function (modifiers) {
		// Merge modifiers with already present ones
		this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

		this.resourceAction.listResource(this.getOptions);
	},

    /**
	 * Register event listeners and fire request for data
	 */
    componentDidMount: function () {
		this.requestTableData();

		this.changeListener = this._onChange;
		MovementsStore.addChangeListener(this.changeListener);
		FormStore.addChangeListener(this.bindResource);
	},

    /**
	 * Deregister an event listener
	 */
    componentWillUnmount: function () {
		MovementsStore.removeChangeListener(this.changeListener);
		FormStore.removeChangeListener(this.bindResource);
	},

    /**
	 * Handle changes in data and request paginated data
	 *
	 * @private
	 */
    _onChange: function () {
		this.setState({
			currentPageData: MovementsStore.getResourceListData()
		});
	},

    formKey: 'editMovement',

    /**
	 * Update the bound resource on change
	 */
    bindResource: function () {
		this.setState({
			workingResource: FormStore.getResource(this.formKey)
		});
	},

    /**
	 * @todo the modals can be their own components
	 * @param action
	 * @param resource
	 */
    handleAction: function (action, resource) {
		switch (action) {
			case 'deactivate':
				this.setState({
					openDeactivateModal: true,
					workingResource:     resource,
					resourceOperation:   action
				});
				break;
			case 'saveRow':
				this.resourceAction.updateResource(resource, this.sendOptions);
				break;
			case 'cancelEditRow':
				this.requestTableData();
				break;
			case 'edit':
				this.setState({
					openEditModal:     true,
					workingResource:   resource,
					resourceOperation: action
				});
				break;
		}
	},

    /**
	 * Fire the update movement action
	 */
    updateMovement: function () {
		this.resourceAction.updateResource(this.state.workingResource, this.sendOptions);
	},

    /**
	 * Close all modals and reset the working resource
	 */
    closeModal: function () {
		this.setState({
			openEditModal:       false,
			openDeactivateModal: false,
			workingResource:     {}
		});
	},

    /**
	 * Map movement object properties to table columns
	 */
    tableKeys: {
		"Image":       "image",
		"Movement":    "label",
		"Description": "description"
	},

    render: function () {
		var options = {
			actionableRows:  true,
			actions:         ['edit:primary'],
			actionsCallback: this.handleAction,
			mutators:        {
				image: function (image, object) {
					return (
						<img className="movement-library-image" src={image} />
					);
				}
			}
		};

		return (
			<div id="page-wrapper">
				<div id="page-content">
					<div id="content"></div>
					<Row classes="align-items-center">
						<Column grid="lg" size="6">
							<h1 className="page-header">Movements</h1>
						</Column>
					</Row>

					<Row>
						<Column grid="lg" size="12">
							<Table data={this.state.currentPageData}
								dataKeys={this.tableKeys}
								title={'Movements'} options={options} />
						</Column>
					</Row>
				</div>

				{this.state.openEditModal && (
					<Modal openWhen={this.state.openEditModal} options={{width: '50%'}}
						title="Edit Movement"
						closeText="Close" saveText="Save"
						afterClose={this.closeModal}
						beforeSave={this.updateMovement}
						afterSave={this.closeModal} >
						<Row>
							<Form key="editMovement" formKey={this.formKey}
								bindResource={this.state.workingResource} >
								<Column grid="sm" size="4">
									<Form.File options={{
										height:  120,
										width:   120,
										bgImage: 'http://imgur.com/nQ4J1lu.jpg'
									}}
										label="Movement Image" onUpload={this.handleUpload}
										helpText="We recommend that you upload an image that is at least 1000px by 1000px" />
								</Column>
								<Column grid="sm" size="8">
									<Form.Input fieldKey="label" type="text" label="Movement Name" placeholder="Enter Name.." limit={120} validations="isLength:4:120" />

									<Form.TextArea fieldKey="description" label="Description" placeholder="Enter Description.."
										limit={285} validations="isLength:1:285" rows="5" />
								</Column>
							</Form>
						</Row>

					</Modal>
				)}
			</div>
		)
	},
});

module.exports = MovementsPage;
